const prefix = 'user';

export default {
    update: `${prefix}.update`,
};



// WEBPACK FOOTER //
// ./scripts/frontend/base/actions/User.js